/// <reference path="../propertypicker/propertypicker.ts" />
/// <reference path="../../../teva/sortable/sortable.ts" />

namespace OfficeGuy.CRM {
    export class Views {
        static AddField(SchemaID, AddLine, SearchField) {
            OfficeGuy.CRM.PropertyPicker.ShowPropertyPicker(SchemaID, function (Path, Name, PathNames, PropertyValueType) {
                AddLine();
                var $Line = $(SearchField ? ".schemaview_searchfields tr:last" : ".schemaview_displayfields tr:last");
                $("input[name$='.Name']", $Line).attr("placeholder", Name);
                $(".path", $Line).text('{' + PathNames + '}');
                $("input[name$='.Path']", $Line).val(Path);
                Views.ReindexFields();
                Common.InitEditors();
            }, true);
            return false;
        }

        static RemoveField($Row) {
            if ($Row.closest("tbody").hasClass("schemaview_searchfields")) {
                var RowID = $("input:first", $Row).attr("name").substring("SearchFields[".length);
                RowID = RowID.substring(0, RowID.indexOf(']'));

                OfficeGuy.Forms.NestedForm_Remove(null, "SearchFields", RowID);
            }
            else {
                var RowID = $("input:first", $Row).attr("name").substring("DisplayFields[".length);
                RowID = RowID.substring(0, RowID.indexOf(']'));

                OfficeGuy.Forms.NestedForm_Remove(null, "DisplayFields", RowID);
            }
            $Row.remove();
        }

        static InitIndex() {
            Teva.Sortable.Enable($(".schemaview_searchfields, .schemaview_displayfields"), {
                HandleSelector: '.icon-drag',
                OnChange: function () {
                    Views.ReindexFields();
                }
            });
        }

        static ReindexFields() {
            var Index = 0;
            $(".schemaview_searchfields input[name*='.Index']").each(function () {
                $(this).val((Index++).toString());
            });
            $(".schemaview_displayfields input[name*='.Index']").each(function () {
                $(this).val((Index++).toString());
            });
        }
    }
}